<template>
  <div v-if="isMounted">
    <div :class="`${classVariableName}-pdp-container`">
      <fdk-accounts
        v-if="!userReviewed || userCurrentReview.tags.includes('RATING_ONLY_REVIEW')"
        v-slot="accountsData"
      >
        <div :class="`${classVariableName}-pdp-review`">
          <div
            v-if="!userReviewed"
            :class="`${classVariableName}-pdp-add-rating-container`"
          >
            <div :class="`${classVariableName}-pdp-add-rating-text`">
              Rate this product
            </div>
            <div :class="`${classVariableName}-pdp-add-rating-icon`">
              <ratingComponent
                :readonly="showAlert"
                :initialRating="rating"
                @updateRating="(event) => {
                  rating = event;
                  postReview(accountsData);
                }"
                size="ml"
                :allowFraction="
                  validationConfig &&
                  parseInt(validationConfig.rating.step) !== validationConfig.rating.step
                "
                :maxStars="maxRating"
              />
            </div>
          </div>
          <div v-else :class="`${classVariableName}-pdp-add-review-container`">
            <div :class="`${classVariableName}-pdp-edit-rating-container`">
              <div :class="`${classVariableName}-pdp-add-rating-text`">
                You rated
              </div>
              <div :class="`${classVariableName}-pdp-edit-rating-text`">
                {{ rating }}
              </div>
              <Star kind="filled" size="s"/>
              <div
                :class="`${classVariableName}-auto-margin-left`"
                @click="()=> editRating(accountsData)"
              >
                <EditButtonVue />
              </div>
            </div>
            <div
              :class="`${classVariableName}-pdp-add-review-button ${
                showAlert ? `disabled` : ''
              }`"
              @click="!showAlert && openAddReviewPopup(accountsData)"
            >
              Review this product
            </div>
          </div>
        </div>
      </fdk-accounts>
      <div :class="`${classVariableName}-mob-rating-main-section`">
        <ratingStatsComponent
          :averageRating="avgRating"
          :totalRatings="ratingsCount"
          :ratingStats="ratingsCountDetails"
          :maximumRating="maxRating"
          :verifiedCount="verifiedCount"
          :viewDetailedStats="detailedStats"
          @updateViewDetailed="(event) => {
            detailedStats = event;
          }"
          :observer="observer"
        />

        <hr :class="`${classVariableName}-mob-vertical-divider`" v-if="imageCount !== 0 && validationConfig && !validationConfig.image.hidden "/>

        <GalleryView
          v-if="
            imageCount !== 0 &&
            validationConfig &&
            !validationConfig.image.hidden
          "
          :validationConfig="validationConfig"
          :userCurrentReview="userCurrentReview"
          :setAlert="(message, type) => toast(message, type)"
          :productId="productId"
          :imageCount="imageCount"
          :product="product"
        />

        <hr :class="`${classVariableName}-mob-vertical-divider`" v-if="reviewsCount !== 0"/>

        <div :class="`${classVariableName}-top-reviews`" v-if="reviewsCount !== 0">
          <div :class="`${classVariableName}-top-reviews-title`">Most helpful reviews</div>
          <div :class="`${classVariableName}-top-reviews-carousel`">
            <ReviewCarousel
              :product="product"
              :validationConfig="validationConfig"
              :userCurrentReview="userCurrentReview"
              :reviews="reviews.length <= 3 ? reviews : reviews.slice(0, 3)"
              :setAlert="(message, type) => toast(message, type)"
            />
          </div>
          <div style="margin: 0 16px;">
            <button
              v-if="reviewsCount>1"
              :class="`${classVariableName}-top-reviews-viewall`"
              @click="() => { this.detailedStats = true; }"
            >
              View all
            </button>
          </div>
        </div>
      </div>

      <addReviewComponent
        v-if="addReview && !isEmpty(validationConfig)"
        :product="product"
        :prdId="productId"
        :varientId="alternateCode1"
        :uid="alternateCode2"
        :prdlink="productURL"
        :prdImgURL="productImage"
        :prdName="productName"
        :categoryL1Id="categoryL1.id"
        :categoryL2Id="categoryL2.id"
        :categoryL3Id="categoryL3.id"
        :categoryL4Id="categoryL4.id"
        :categoryL1Name="categoryL1.name"
        :categoryL2Name="categoryL2.name"
        :categoryL3Name="categoryL3.name"
        :categoryL4Name="categoryL4.name"
        :reload="init"
        :onCloseAndRefresh="init"
        :onClose="onClose"
        :showAlert="isEmpty(showAlert) ? false : showAlert"
        :setAlert="(message, type) => toast(message, type)"
        :initialRating="rating"
        :initialReview="userCurrentReview"
        :validationConfig="validationConfig"
        :userName="userName"
      />
      <VerifiedPurchaserSidePanel v-if="showErrorModal" :onClose="onClose" />
    </div>

    <alertComponent
      v-if="!isEmpty(showAlert)"
      :type="alertType"
      :message="alertMessage"
      :showAlert="showAlert"
    />

    <ReviewDetailsModal v-if="detailedStats"
      :onClose="() => {
        detailedStats = false;
        filters = {};
        getReviews();
      }"
      :getNextPage="getNextPage"
      :loading="scrollInProcess"
      :openImageReviewDetailsModal="(event) => { openReviewDetails(event); }"

      :averageRating="avgRating"
      :totalRatings="ratingsCount"
      :ratingStats="ratingsCountDetails"
      :maximumRating="maxRating"
      :verifiedCount="verifiedCount"

      :validationConfig="validationConfig"
      :userCurrentReview="userCurrentReview"
      :setAlert="(message, type) => toast(message, type)"
      :productId="productId"
      :imageCount="imageCount"
      :product="product"

      :reviewStats="reviewsCountDetails"
      :variantStats="variantDetails"
      :originDetails="originDetails"
      :getFilteredReviews="getFilteredReviews"
      :filters="filters"

      :reviews="reviews"
    />
  </div>
</template>
<script>
import addReviewComponent from "./components/AddReview.vue";
import ratingStatsComponent from "./components/mob/RatingStats.vue";
import ratingComponent from "./components/common/StarRating.vue";
import alertComponent from "./components/common/Alert.vue";
import Star from "./components/common/Star.vue";
import GalleryView from "./components/mob/GalleryView.vue";
import VerifiedPurchaserSidePanel from "./components/VerifiedPurchaserSidePanel.vue";
import {
  getStorageWithExpiry,
  isEmpty,
  setStorageWithExpiry,
  FEEDBACK_VALIDATION_CONFIG_KEY,
  FEEDBACK_VALIDATION_CONFIG_TTL,
  classVariableName,
  getEventData,
  emitEvent
} from "./utils.js";
import CUSTOM_EVENTS from "./constants.js";
import customerServices from "./services/customer-review.js";
import configuration from "./services/configuration.js";
import EditButtonVue from "./components/common/EditButton.vue";
import ReviewCarousel from "./components/mob/ReviewCarousel.vue";
import ReviewDetailsModal from "./components/mob/ReviewDetailsModal.vue";

export default {
  name: "ReviewsComponent",
  components: {
    addReviewComponent,
    ratingStatsComponent,
    ratingComponent,
    alertComponent,
    Star,
    EditButtonVue,
    GalleryView,
    VerifiedPurchaserSidePanel,
    ReviewCarousel,
    ReviewDetailsModal,
  },
  computed: {},
  data() {
    return {
      observer: null,
      // review
      validationConfig: null,
      pageNo: 0,
      sortBy: "ORIGIN_BASED_MOST_RECENT",
      filters: null,
      hasNext: false,
      reviews: [],
      addReview: false,
      avgRating: null,
      maxRating: 0,
      ratingsCountDetails: null,
      reviewsCountDetails: null,
      variantDetails: null,
      originDetails: null,
      ratingsCount: 0,
      reviewsCount: 0,
      verifiedCount: 0,
      imageCount: 0,
      isTIRA: false,
      isBV: false,
      noReviews: false,
      showAlert: null,
      alertType: "success",
      alertMessage: null,
      userCurrentReview: null,
      userReviewed: false,
      isPendingReview: false,
      rating: 0,
      showErrorModal: false,
      scrollInProcess: false,
      // product
      product: {},
      productId: null,
      alternateCode1: null,
      alternateCode2: null,
      categoryL1: {
        id: null,
        name: null,
      },
      categoryL2: {
        id: null,
        name: null,
      },
      categoryL3: {
        id: null,
        name: null,
      },
      categoryL4: {
        id: null,
        name: null,
      },
      productURL: null,

      baseURL: null,
      productName: null,
      productImage: null,
      isMounted: false,
      classVariableName: classVariableName,
      userName: null,

      detailedStats: false,
    };
  },
  mounted() {
    console.log("mob mounting");
    this.isMounted = true;
    this.baseURL = window.location.origin;
    window.FPI.state.product.subscribe(this.getProducts.bind(this));
  },
  destroy() {
    window.FPI.state.product.unsubscribe(this.getProducts.bind(this));
  },
  created() {
    this.observer = new IntersectionObserver(
      this.onElementObserved,
      {
        root: this.$el,
        threshold: 1.0,
      }
    );
  },
  beforeDestroy() {
    this.observer.disconnect();
  },
  watch: {},
  methods: {
    isEmpty(val) {
      return isEmpty(val);
    },
    async editRating(accountsData) {
      if (this.showAlert) return;
      emitEvent(CUSTOM_EVENTS.EDIT_RATING, getEventData(accountsData.is_logged_in, 'PDP', this.product, this.userCurrentReview));
      this.openAddReviewPopup(accountsData);
    },
    onElementObserved(entries) {
      entries.forEach(({ target, isIntersecting }) => {
        if (!isIntersecting) {
          return;
        }

        this.observer.unobserve(target);

        setTimeout(() => {
          console.log("sending mob impression event");
           let extendedProductDetails = { ...this.product, isTIRA: this.isTIRA, isBV: this.isBV, noReviews: this.noReviews, avgRating: this.avgRating };
          emitEvent(CUSTOM_EVENTS.PDP_REVIEW_IMPRESSIONS, getEventData(!isEmpty(Object.keys(window.FPI.state.user._data)), 'PDP', extendedProductDetails, null));
        }, 1000)

      });
    },

    async postReview(accountsData) {
      emitEvent(CUSTOM_EVENTS.RATE_THIS_PRODUCT, getEventData(accountsData.is_logged_in,'PDP',this.product,{rating: this.rating}));
      if (!accountsData.is_logged_in) {
        accountsData.openLogin();
      }
      let allowed = await this.getIfAllowedToReview();
      if (!allowed) {
        this.rating = 0;
        console.log("not allowed to review!");
        return;
      }
      let data = {
        productId: this.productId,
        alternateCode1: this.alternateCode1,
        alternateCode2: this.alternateCode2,
        productURL: this.productURL,
        categoryL1: !isEmpty(this.categoryL1)
          ? this.categoryL1
          : undefined,
        categoryL2: !isEmpty(this.categoryL2)
          ? this.categoryL2
          : undefined,
        categoryL3: !isEmpty(this.categoryL3)
          ? this.categoryL3
          : undefined,
        categoryL4: !isEmpty(this.categoryL4)
          ? this.categoryL4
          : undefined,
        rating: this.rating,
        ingressPoint: "PDP",
      };
      return await customerServices
        .postReview(data)
        .then((data) => {
          let resp = data.data;
          if (resp.resultInfo.status === "SUCCESS") {
            this.toast("Your rating is submitted", "success");
            emitEvent(CUSTOM_EVENTS.SUBMIT_RATING, getEventData(accountsData.is_logged_in, 'PDP', this.product, resp.data ));
            this.init();
            this.addReview = true;
            this.userName =
              accountsData.user_data.user.first_name +
              " " +
              accountsData.user_data.user.last_name;
            window.ratingUpdated = true;
          } else {
            this.toast(resp.resultInfo.message, "error");
            this.onClose();
          }
        })
        .catch((error) => {
          this.toast(error.response.data.info.resultInfo.message, "error");
          this.onClose();
        });
    },
    async openAddReviewPopup(accountsData) {
      if (!accountsData.is_logged_in) {
        accountsData.openLogin();
      }
      this.addReview = true;
      this.userReviewed = true;
      this.userName =
        accountsData.user_data.user.first_name +
        " " +
        accountsData.user_data.user.last_name;
    },

    async getIfAllowedToReview() {
      try {
        let response = await customerServices.getIfVerifiedPurchase(
          this.alternateCode1
        );
        let resp = response.data;
        if (resp.resultInfo.status === "SUCCESS") {
          if (!resp.data.reviewAllowed) {
            emitEvent(CUSTOM_EVENTS.REVIEW_NOT_ELIGIBLE_POPUP, getEventData(true, 'PDP', this.product, {rating: this.rating}));
            this.showErrorModal = true;
            return false;
          }
          this.showErrorModal = false;
          return true;
        }
      } catch (error) {
        this.toast(error, "warning");
        return false;
      }
    },

    async getReviews(reset = true) {
      let query = {
        ...this.filters,
        pageNo: this.pageNo,
        pageSize: 3,
        sortBy: this.sortBy,
      };
      return await customerServices
        .getAllReviews(this.productId, query)
        .then((data) => {
          let res = data.data;
          if (res.resultInfo.status === "SUCCESS") {
            if (reset) this.reviews = [];
            if (res.data.reviews.length !== 0) {
              this.reviews = [...this.reviews, ...res.data.reviews];
            }
            this.hasNext = res.data.page.hasNext;
            this.scrollInProcess = false;
          } else {
            this.toast(res.resultInfo.message, "error");
          }
        });
    },
    async getUserReview() {
      let query = {
        productId : this.productId, 
        alternateCode1 : this.alternateCode1
      };
      return await customerServices
        .getProductVariantReviewOfUser(query)
        .then(async (data) => {
          let res = data.data;
          if (res.resultInfo.status === "SUCCESS") {
            if (!isEmpty(res.data)) {
              var isPendingReview = await this.checkIfReviewInPendingState(
                res.data
              );
              if (isPendingReview) this.userCurrentReview = res.data["PENDING"];
              else this.userCurrentReview = res.data["APPROVED"];
              this.userReviewed = true;
              this.isPendingReview = isPendingReview;
              this.rating = this.userCurrentReview.rating;
            }
          }
        })
        .catch(() => {
          this.rating = 0;
        });
    },
    async getReviewValidationConfig() {
      var config = getStorageWithExpiry(FEEDBACK_VALIDATION_CONFIG_KEY);
      if (!isEmpty(config)) {
        this.validationConfig = config;
        this.maxRating = config.rating.max;
        return;
      }
      return await configuration
        .getValidationConfig()
        .then((data) => {
          let res = data.data;
          if (res.resultInfo.status === "SUCCESS") {
            config = res.data.data;
            this.validationConfig = config;
            this.maxRating = config.rating.max;
            setStorageWithExpiry(
              FEEDBACK_VALIDATION_CONFIG_KEY,
              config,
              FEEDBACK_VALIDATION_CONFIG_TTL
            );
          } else {
            this.toast(res.resultInfo.message, "error");
          }
        })
        .catch((error) => console.error(error));
    },
    async checkIfReviewInPendingState(reviewMap) {
      return !isEmpty(reviewMap["PENDING"]);
    },
    async toast(message, type) {
      this.alertMessage = message;
      this.showAlert = true;
      this.alertType = type;
      setTimeout(() => {
        this.showAlert = false;
      }, 3000);
    },
    async getProductSummary() {
      return await customerServices
        .getProductStats(this.productId)
        .then((data) => {
          let res = data.data;
          if (res.resultInfo.status !== "SUCCESS") {
            this.toast(res.resultInfo.message, "error");
          } else if (
            res.resultInfo.status === "SUCCESS" &&
            !isEmpty(res.data)
          ) {
            this.avgRating = res.data.averageRating;
            this.ratingsCountDetails = res.data.ratingsCountDetails;
            this.reviewsCountDetails = res.data.reviewsCountDetails;
            this.originDetails = res.data.originDetails;
            this.variantDetails = res.data.variantDetails.reduce((vmap, obj) => {
              vmap[obj.alternateCode2] = obj;
              return vmap;
            }, {});
            this.ratingsCount = res.data.ratingsCount;
            this.reviewsCount = res.data.reviewsCount;
            this.verifiedCount = res.data.verifiedCount;
            this.imageCount = res.data.imageCount;
            let sources = res.data.sources;
            if (!isEmpty(sources) && sources.indexOf("BV")!=-1) {
              this.isBV = true;
            }
            else if (!isEmpty(sources) && (sources.indexOf("PDP")!=-1 || sources.indexOf("TIRA")!=-1)) {
              this.isTIRA = true;
            }
            else if (isEmpty(sources) && isEmpty(this.avgRating)) {
              this.noReviews = true;
            }
          } else if (isEmpty(res.data)) {
              this.noReviews = true;
          }
        })
        .catch((error) => console.error(error));
    },  
    async getProducts(product) {
      let newProductId = (product.product.attributes && product.product.attributes['group-product-id']) ? Array.isArray(product.product.attributes['group-product-id']) ? product.product.attributes['group-product-id'][0] : product.product.attributes['group-product-id'] : product.product.item_code;
      if (this.productId !== newProductId) {
        this.productId = newProductId;
        this.alternateCode1 = product.product.item_code;
        this.alternateCode2 = product.product.uid;
        if (!isEmpty(product.product.category_map)) {
          let category1 = product.product.category_map.l1;
          let category2 = product.product.category_map.l2;
          let category3 = product.product.category_map.l3;
          let category4 = product.product.category_map.l4;

          if (!isEmpty(category1)) {
            this.categoryL1 = {
              ...category1,
            };
          }
          if (!isEmpty(category2)) {
            this.categoryL2 = {
              ...category2,
            };
          }
          if (!isEmpty(category3)) {
            this.categoryL3 = {
              ...category3,
            };
          }
          if (!isEmpty(category4)) {
            this.categoryL4 = {
              ...category4,
            };
          }
        }
        this.productName = product.product.name;
        this.productImage = product.product.medias[0].url;
        this.productURL = this.baseURL + "/" + product.product.type + "/" + product.product.slug;
        this.product = {
          ...this.product,
          ...product.product
        };
        this.init();
      }
    },
    onClose() {
      this.addReview = false;
      this.showErrorModal = false;
    },
    init() {
      console.log("productMob", this.product);
      this.resetInitials();
      this.getReviews();
      this.getReviewValidationConfig();
      this.getProductSummary();
      this.getUserReview();
    },
    async resetInitials() {
      this.validationConfig= null,
      this.pageNo= 0,
      this.sortBy= "ORIGIN_BASED_MOST_RECENT",
      this.filters= null,
      this.hasNext= false,
      this.reviews= [],
      this.addReview= false,
      this.avgRating= null,
      this.maxRating= 0,
      this.ratingsCountDetails= null,
      this.reviewsCountDetails= null,
      this.variantDetails= null,
      this.ratingsCount= 0,
      this.reviewsCount= 0,
      this.verifiedCount= 0,
      this.imageCount= 0,
      this.showAlert= null,
      this.alertType= "success",
      this.alertMessage= null,
      this.userCurrentReview= null,
      this.userReviewed= false,
      this.isPendingReview= false,
      this.showErrorModal= false,
      this.scrollInProcess= false
    },

    async getFilteredReviews(filters) {
      emitEvent(CUSTOM_EVENTS.REVIEWS_FILTER_APPLY, getEventData(!isEmpty(Object.keys(window.FPI.state.user._data)), 'PDP', this.product, this.userCurrentReview));
      let queryFilters = {};
      if (!isEmpty(filters.rating.items)) {
        queryFilters.starRating = filters.rating.items;
      }
      if (!isEmpty(filters.color.items)) {
        let selectedVariants = [];
        filters.color.items.forEach(variant => {
          selectedVariants.push(this.variantDetails[variant].alternateCode1)
        });
        queryFilters.variants = selectedVariants;
      }
      if (!isEmpty(filters.origin.items)) {
        queryFilters.origins = filters.origin.items;
      }
      if (filters.image.selected) {
        queryFilters.tags = "IMAGE_REVIEW";
      }
      if (filters.upvote.selected) {
        this.sortBy = "MOST_HELPFUL";
      } else {
        this.sortBy = "ORIGIN_BASED_MOST_RECENT";
      }
      this.filters = { ...queryFilters };
      this.pageNo = 0;
      await this.getReviews();
    },

    async getNextPage() {
      if (this.hasNext) {
        this.scrollInProcess = true;
        this.pageNo = this.pageNo + 1;
        return await this.getReviews(false);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./assets/Mob.scss";
@import "./assets/Pdp.scss";
</style>
